import { __module as toPropertyKey } from '../../../../_virtual/toPropertyKey.js';
import './typeof.js';
import './toPrimitive.js';
import { exports as _typeofExports } from '../../../../_virtual/typeof.js';
import { exports as toPrimitiveExports } from '../../../../_virtual/toPrimitive.js';

(function (module) {
	var _typeof = _typeofExports["default"];
	var toPrimitive = toPrimitiveExports;
	function toPropertyKey(t) {
	  var i = toPrimitive(t, "string");
	  return "symbol" == _typeof(i) ? i : i + "";
	}
	module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;
} (toPropertyKey));
//# sourceMappingURL=toPropertyKey.js.map
